export default __webpack_public_path__ + "074c7071e8f6c9021e0523b3b5706d65.png";